import React from "react";
import "../../css/LoadAgent.css";
import PropTypes from "prop-types";
import StatusBadge from "../Badgse";

function AiAgent({ backgroundColor, image, title, subtitle, status,onClick }) {
  const getStatus = (name) => {
    switch (name) {
      case "processed":
        return { label: "processed", color: "orange" };

      case "success":
        return { label: "success", color: "green" };
        case "rejected":
          return { label: "rejected", color: "red" };
      default:
        return { label: "", color: "" };
    }
  };

  return (
    <div onClick={onClick} className="agent-container">
      <div style={{flexDirection:'row',display:'flex'}}>
        <div style={{justifyContent:'center',alignItems:'center',display:'flex'}}>
        <img
        className="agent-image"
        src={image}
        alt={title}
        style={{ backgroundColor: backgroundColor }}
      />
        </div>
     
      <div  style={{marginLeft:30}} className="agentText-container">
        <h3 className="agent-header">{title}</h3>
        <p className="agent-text">{subtitle}</p>
      </div>
      </div>
    
 
      {status &&<StatusBadge status={getStatus(status).label} color={getStatus(status).color} />}
    </div>
  );
}

AiAgent.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};

export default AiAgent;
